export interface EmailActionLocation {
  pathname: string;
  search: string;
  hash: string;
}

export interface EmailActionBootstrapState {
  searchParams: URLSearchParams;
  token: string | null;
}

/**
 * Copies a one-time email token into in-memory router state and scrubs it from
 * the visible URL before React renders. Query tokens remain supported only for
 * links created before the fragment migration.
 */
export function consumeEmailActionToken(
  location: EmailActionLocation,
  replaceUrl: (url: string) => void,
): EmailActionBootstrapState {
  const visibleParams = new URLSearchParams(location.search);
  const fragmentParams = new URLSearchParams(location.hash.replace(/^#/u, ""));
  const fragmentToken = fragmentParams.get("token");
  const legacyQueryToken = visibleParams.get("token");
  const token = fragmentToken ?? legacyQueryToken;

  if (fragmentToken !== null || legacyQueryToken !== null) {
    visibleParams.delete("token");
    fragmentParams.delete("token");
    const cleanSearch = visibleParams.toString();
    const cleanFragment = fragmentParams.toString();
    replaceUrl(
      `${location.pathname}${cleanSearch ? `?${cleanSearch}` : ""}`
      + `${cleanFragment ? `#${cleanFragment}` : ""}`,
    );
  }

  const inMemoryParams = new URLSearchParams(visibleParams);
  if (token !== null) inMemoryParams.set("token", token);
  return { searchParams: inMemoryParams, token };
}
